<!-- Features Section -->
<div class="relative isolate">
  <div class="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
    <!-- Section Header -->
    <div class="mx-auto max-w-2xl text-center" @fadeInUp>
      <h2 class="text-base font-semibold leading-7 text-indigo-600">
        {{ "features.page.title" | translate }}
      </h2>
      <p
        class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
      >
        {{ "features.page.subtitle" | translate }}
      </p>
      <p class="mt-6 text-lg leading-8 text-gray-600">
        {{ "features.page.description" | translate }}
      </p>
    </div>

    <!-- Feature Blocks -->
    <div class="mx-auto mt-16 max-w-7xl space-y-20">
      <!-- Feature Block -->
      <div
        *ngFor="let block of featureBlocks; let isEven = even"
        class="relative"
        @scaleIn
      >
        <!-- Background Gradient -->
        <div class="absolute inset-0 rounded-3xl"></div>

        <!-- Content Container -->
        <div
          class="relative rounded-3xl bg-white backdrop-blur-xl ring-1 ring-gray-900/10 shadow-xl"
        >
          <div class="grid lg:grid-cols-2 gap-x-8 gap-y-16">
            <!-- Image Section -->
            <div [class]="isEven ? 'lg:order-2' : ''">
              <div class="relative h-[500px] overflow-hidden rounded-2xl">
                <!-- Placeholder or actual image -->
                <div
                  [class]="
                    'absolute inset-0 ' +
                    (block.key === 'core'
                      ? 'core-features-placeholder'
                      : block.key === 'advanced'
                      ? 'advanced-features-placeholder'
                      : 'applications-placeholder') +
                    ' placeholder-image'
                  "
                >
                  <img
                    [src]="block.image"
                    [alt]="block.title | translate"
                    class="absolute inset-0 h-full w-full object-cover transition duration-200 hover:scale-105 transform-gpu will-change-transform"
                    loading="lazy"
                    decoding="async"
                    style="opacity: 0"
                    (error)="onImageError($event)"
                    (load)="onImageLoad($event)"
                  />
                </div>
                <div
                  class="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-gray-900/0"
                ></div>
              </div>
            </div>

            <!-- Features Grid -->
            <div [class]="isEven ? 'lg:order-1' : ''" class="p-8">
              <h3
                class="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl mb-2"
              >
                {{ block.title | translate }}
              </h3>
              <p class="text-lg text-gray-600 mb-8">
                {{ block.description | translate }}
              </p>

              <!-- Features Grid -->
              <div class="grid gap-6 sm:grid-cols-2">
                <div
                  *ngFor="let feature of block.features | translate"
                  class="relative group rounded-xl p-6 hover:bg-gray-50 transition-all duration-200 will-change-transform"
                >
                  <!-- Icon -->
                  <div
                    [class]="
                      'absolute h-10 w-10 rounded-lg ' +
                      feature.color +
                      ' bg-white flex items-center justify-center ring-1 ring-gray-900/10 shadow-md transition-transform duration-200 will-change-transform transform-gpu group-hover:-translate-y-1 rtl:right-0 ltr:left-0'
                    "
                  >
                    <svg
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                    >
                      <path
                        [attr.d]="feature.icon"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>

                  <!-- Content -->
                  <div class="ml-14 rtl:mr-14 rtl:ml-0">
                    <h4
                      class="text-base font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors duration-200"
                    >
                      {{ feature.title }}
                    </h4>
                    <p class="mt-2 text-sm text-gray-600">
                      {{ feature.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div class="mt-32 text-center" @fadeInUp>
      <div class="inline-flex rounded-3xl bg-gray-900/5 p-2">
        <span
          class="rounded-2xl bg-gray-900/10 px-4 py-2 text-sm font-medium text-gray-900"
        >
          {{ "features.page.cta.badge" | translate }}
        </span>
      </div>
      <h2 class="mt-6 text-3xl font-bold tracking-tight text-gray-900">
        {{ "features.page.cta.title" | translate }}
      </h2>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <a
          routerLink="/pricing"
          class="rounded-xl bg-indigo-600 px-8 py-4 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300 hover:scale-105"
        >
          {{ "features.page.cta.primary_button" | translate }}
        </a>
        <a
          routerLink="/contact-us"
          class="text-sm font-semibold leading-6 text-gray-900 flex items-center group"
        >
          {{ "features.page.cta.secondary_button" | translate }}
          <span
            class="ml-2 rtl:mr-2 rtl:ml-0 rtl:rotate-180 transition-transform duration-300 group-hover:translate-x-2 rtl:group-hover:-translate-x-2"
            aria-hidden="true"
            >→</span
          >
        </a>
      </div>
    </div>
  </div>
</div>
